import React, { Component } from 'react'
import PropTypes from 'prop-types'
import styles from './Heading.css'

class Heading extends Component {
  render () {
    let {children, headingLevel, styleLevel, className, ...otherAttributes} = this.props

    if (!styleLevel && styleLevel !== 0) {
      styleLevel = headingLevel
    }

    const headingStyle = styleLevel === 0 ? '' : styles[`h${styleLevel}_style`]
    const styleInfo = `hw-heading-${styleLevel} ${styles.heading_reset} ${className} ${headingStyle}`.replace('  ', ' ')

    let header = <p>{children}</p>
    switch (this.props.headingLevel) {
      case 1:
        header = (
          <h1 className={styleInfo} {...otherAttributes}>{children}</h1>
        )
        break
      case 2:
        header = (
          <h2 className={styleInfo} {...otherAttributes}>{children}</h2>
        )
        break
      case 3:
        header = (
          <h3 className={styleInfo} {...otherAttributes}>{children}</h3>
        )
        break
      case 4:
        header = (
          <h4 className={styleInfo} {...otherAttributes}>{children}</h4>
        )
        break
      case 5:
        header = (
          <h5 className={styleInfo} {...otherAttributes}>{children}</h5>
        )
        break
      case 6:
        header = (
          <h6 className={styleInfo} {...otherAttributes}>{children}</h6>
        )
        break
    }

    return header
  }
}

Heading.propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  headingLevel: PropTypes.oneOf([1, 2, 3, 4, 5, 6]).isRequired,
  styleLevel: PropTypes.oneOf([0, 1, 2, 3, 4, 5, 6])
}

Heading.defaultProps = {
  children: '&nbsp;',
  className: ''
}

export default Heading



// WEBPACK FOOTER //
// /src/~/@healthwise/enhanced-shared-decision-point/components/Heading/index.js